import * as React from 'react';
import { SVGProps } from 'react';

const GoogleIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} fill="none" {...props}>
    <path
      fill="#4285F4"
      fillRule="evenodd"
      d="M17.64 9.734c0-.638-.057-1.252-.164-1.84H9v3.48h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615Z"
      clipRule="evenodd"
    />
    <path
      fill="#34A853"
      fillRule="evenodd"
      d="M9 18.531c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18.53Z"
      clipRule="evenodd"
    />
    <path
      fill="#FBBC05"
      fillRule="evenodd"
      d="M3.964 11.24a5.41 5.41 0 0 1-.282-1.71c0-.592.102-1.17.282-1.71V5.49H.957A8.996 8.996 0 0 0 0 9.531c0 1.452.348 2.827.957 4.042l3.007-2.332Z"
      clipRule="evenodd"
    />
    <path
      fill="#EA4335"
      fillRule="evenodd"
      d="M9 4.11c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463 1.421 11.426.53 9 .53A8.997 8.997 0 0 0 .957 5.488L3.964 7.82C4.672 5.693 6.656 4.11 9 4.11Z"
      clipRule="evenodd"
    />
  </svg>
);

export default GoogleIcon;
